import produce from 'immer';
import moment from 'moment';
import { createAction, handleActions } from 'redux-actions';

import { TYPE } from '../constant';
import { mathpidLogAPI } from '../api/logDataAPI';
import { getAppId, getUserAgent } from '../utils/utilityEtc';

/**
 * @param {object} actor:
 * @param {object} verb:
 * @param {object} object:
 * @param {object} context:
 * @param {string} timestamp:
 */


const defaultState = {
  actor: {
    account: {
      homePage: "",
      name: ""
    },
    name: "",
    objectType: "Agent"
  },
  timestamp: moment().format(),
  verb: {
    id: "",
    display: {
      'en-US': ""
    }
  },
  object: {
    id: "",
    definition: {
      name: {
        'en-US': ""
      },
      extensions: {
        "http://object/extension/objectInfo": {
          idValue: "",
          idName: ""
        }
      },
      description: {
        http: "POST",
        url: "http://xapi.wjtb.kr/data/xAPI/statements"
      }
    },
    objectType: "Activity"
  },
  context: {
    extensions: {
      "http://context/extension/userInfo": {
        userType: 'USER',
        ssaid: getAppId(),
        ipAddress: '',
      },
      "http://context/extension/timeInfo": {
        timeZone: getUserAgent('timeZone'),
      },
      "http://context/extension/envInfo": {
        deviceType: getUserAgent('DEVICE_TYPE'),
        osType: getUserAgent('OS_TYPE'),
        programType: "WEB",
      },
      "http://context/extension/serviceInfo": {
        appPackageId: getUserAgent('packageName'),
        appVersion: getUserAgent('VERSION_NAME'),
        className: `${getUserAgent('packageName')}.mainActivity`
      },
      "http://context/extension/contentInfo": {},
      "http://context/extension/extraInfo": {},
    }
  },
  version: '1.0.4'
}

const SET_ACTOR = 'logData/SET_ACTOR';
const SET_TIMESTAMP = 'logData/SET_TIMESTAMP';
const SET_VERB = 'logData/SET_VERB';
const SET_OBJECT = 'logData/SET_OBJECT';
const SET_CONTEXT = 'logData/SET_CONTEXT';
const SET_USERINFO = 'logData/SET_USERINFO';
const SET_VERB_OBJECT = 'logData/SET_VERB_OBJECT';
const INITIALIZE = 'logData/INITIALIZE';
const SET_METHPID_DATA = 'logData/SET_METHPID_DATA';

export const setActor = createAction(SET_ACTOR, (data) => data);
export const setTimestemp = createAction(SET_TIMESTAMP, () => moment(new Date()).format());
export const setVerb = createAction(SET_VERB, (data) => data);
export const setObject = createAction(SET_OBJECT, (data) => data);
export const setContext = createAction(SET_CONTEXT, (data) => data);
export const setUserInfo = createAction(SET_USERINFO, (data) => data);
export const setVerbObject = createAction(SET_VERB_OBJECT, (data) => data);
export const initial = createAction(INITIALIZE);

export const mathpidLogAPICall = createAction(SET_METHPID_DATA, (data) => data);

const verbLog = (state, data) => produce(state, draft => {
  draft.verb = {
    id: `http://stdlog.wjtb.net/verb/${data.verbId}`,
    display: {
      "en-US": data.verbId
    },
  }
});

const objectLog = (state, data) => produce(state, draft => {
  let objectInfo = {};

  if (data?.screenCode && data?.screenVersion) {
    objectInfo = {
      idName: data.screenVersion,
      idValue: data.screenCode,
    }
  } else if(data?.idName && data?.idValue) {
    objectInfo = {
      idValue: data.idValue,
      idName: data.idName
    }
  }

  draft.object = {
    id: `http://stdlog.wjtb.net/activity/${data.objectId}`,
    definition: {
      name: {
        "en-US": data.objectId
      },
      extensions: {
        "http://object/extension/contentId": {...objectInfo}
      },
      description: draft.object.definition.description,
    },
    objectType: draft.object.objectType
  }
});

const contextLog = (state, data) => produce(state, draft => {
  draft.context.extensions["http://context/extension/contentInfo"] = {...data.contentInfo};
  draft.context.extensions["http://context/extension/extraInfo"] = { ...data.extraInfo };
});

const logData = handleActions(
  {
    [SET_ACTOR]: (state, { payload: data }) => {
      if (data?.account?.homePage) {
        switch (data.account.homePage) {
          case TYPE.ENTRY_TYPE.WJTB:
            data.account.homePage = 'http://stdlog.wjtb.net/service/svc_0005_0004_0000000001';
            break;
          case TYPE.ENTRY_TYPE.GM:
            data.account.homePage = 'http://stdlog.wjtb.net/service/svc_0005_0004_0000000002';
            break;
          case TYPE.ENTRY_TYPE.GM_APP:
            data.account.homePage ='http://stdlog.wjtb.net/service/svc_0005_0004_0000000002';
            break;
          case TYPE.ENTRY_TYPE.GLOBAL01:
            data.account.homePage ='http://stdlog.wjtb.net/service/svc_0005_0004_0000000003';
            break;
        }
      }

      return produce(state, draft => {
        draft.actor = {
          ...state.actor,
          ...data,
        }
      })
    },
    [SET_TIMESTAMP]: (state, { payload: data }) => {
      return produce(state, draft => {draft.timestamp = data})
    },
    [SET_VERB]: (state, { payload: data }) => {
      return verbLog(state, data);
    },
    [SET_OBJECT]: (state, { payload: data }) => {
      return objectLog(state, data);
    },
    [SET_CONTEXT]: (state, { payload: data }) => {
      return contextLog(state, data);
    },
    [SET_USERINFO]: (state, { payload: data }) => {
      return produce(state, draft => {
        draft.context.extensions["http://context/extension/userInfo"].ipAddress = data.ipAddress

      })
    },
    [SET_VERB_OBJECT]: (state, { payload: data }) => {
      const v = verbLog(state, data);
      const o = objectLog(state, data);
      
      return produce(state, draft => {
        draft.verb = v.verb;
        draft.object = o.object;
      });
    },
    [INITIALIZE]: (state) => {
      return produce(state, draft => {
        draft.verb = defaultState.verb;
        draft.object = defaultState.object;
        draft.context = defaultState.context;
      });
    },
    [SET_METHPID_DATA]: (state, { payload: data }) => {
      let d = { ...state };
      // 세팅할 log 데이터가 있을 때 
      if (data) {
        const v = verbLog(state, data);
        const o = objectLog(state, data);
        const c = contextLog(state, data);

        d =  produce(state, draft => {
          draft.verb = v.verb;
          draft.object = o.object;
          draft.context = c.context;
          draft.timestamp = moment(new Date()).format()
        })
      }

      // if (d.actor.account.homePage === 'http://stdlog.wjtb.net/service/svc_0005_0003_0000000001'
      //   || d.actor.account.homePage === 'http://stdlog.wjtb.net/service/svc_0005_0003_0000000003') {
      //   mathpidLogAPI(d);
      // }

      mathpidLogAPI(d);

      // log api 호출 후 log data 초기화
      return produce(state, draft => {
        draft.verb = defaultState.verb;
        draft.object = defaultState.object;
        draft.context.extensions = {
          ...defaultState.context.extensions,
          "http://context/extension/userInfo": draft.context.extensions["http://context/extension/userInfo"]
        }
      });
    }
  },
  defaultState
);

export default logData;